import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getCompany, createCompany } from '../lib/api';

const CompanySetup = () => {
  const [companyName, setCompanyName] = useState('');
  const [companySize, setCompanySize] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (!user) {
        setError('You must be logged in to create a company');
        setLoading(false);
        return;
      }

      // API handles check-if-exists + create in one call
      const result = await createCompany({ name: companyName, size: companySize });

      // Redirect back to where they came from or dashboard
      const params = new URLSearchParams(window.location.search);
      const returnTo = params.get('returnTo') || '/dashboard';
      if (returnTo.includes('?')) {
        window.location.href = returnTo;
      } else {
        navigate(returnTo);
      }
    } catch (err) {
      console.error('Error creating company:', err);
      setError(err.message || 'Failed to create company');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--light-gray)' }}>
      <div style={{ width: '100%', maxWidth: '500px', padding: '2rem' }}>
        <div className="card-emphasis">
          <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
            <h1 style={{ fontSize: '2rem', fontWeight: 700, marginBottom: '1rem' }}>
              Setup Your Company
            </h1>
            <p style={{ color: 'var(--gray)' }}>
              Before you can use services, we need some basic information about your organization.
            </p>
          </div>

          {error && (
            <div style={{ background: '#fee2e2', color: '#991b1b', padding: '0.75rem', borderRadius: '0.5rem', marginBottom: '1rem', fontSize: '0.875rem' }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1.5rem' }}>
              <label className="form-label">Company Name</label>
              <input
                type="text"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                required
                className="form-input"
                placeholder="Acme Corporation"
              />
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <label className="form-label">Company Size</label>
              <select
                value={companySize}
                onChange={(e) => setCompanySize(e.target.value)}
                required
                className="form-input"
              >
                <option value="">Select size</option>
                <option value="1-10">1-10 employees</option>
                <option value="10-25">10-25 employees</option>
                <option value="25-50">25-50 employees</option>
                <option value="50-100">50-100 employees</option>
                <option value="100+">100+ employees</option>
              </select>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary"
              style={{ width: '100%' }}
            >
              {loading ? 'Setting up...' : 'Continue'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CompanySetup;
